import { ReactElement, useEffect, useState, useRef } from 'react';
import { IRouteComponentProps, history } from 'umi';
import { useIntl } from 'react-intl';
// import Context from '@/utils/context';
import { useSelector } from 'dva';
import { getCustomersPoliciesList } from '../service';
import { handleOnScroll } from '@/utils/common';
import PoliciesListItem from '@/components/policies-list-item/policies-list-item';
import { BackButton } from '@/components/back-button/back-button';
import SkeletonLoading from '@/components/skeleton-loading';
import EmptyView from '@/components/empty-view/empty-view';

const Policies = ({ location }: IRouteComponentProps) => {
  const { id } = location.query;
  const { formatMessage } = useIntl();
  const cursor = useRef('0');
  // const { isPc } = useContext(Context);
  const { currentLang } = useSelector<ReduxState, GlobalState>(
    (state) => state.global,
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [policyList, setPolicyList] = useState<any>(false);

  const getData = (isScroll: boolean) => {
    if (window.location.pathname !== '/customers/policies') return;
    if (cursor.current === '' || cursor.current === '1') return;
    if (cursor.current === '0' && isScroll) return;
    getCustomersPoliciesList({
      cursor: cursor.current,
      size: 20,
      order: 'desc',
      customer_id: id,
    })
      .then((res) => {
        if (res) {
          if (cursor.current === '0') {
            setPolicyList(res);
          } else {
            if (res.list) {
              setPolicyList((newObj: any) => {
                return {
                  list: [...newObj.list, ...res.list],
                  cursor: res.cursor,
                };
              });
            }
          }
          cursor.current = res.cursor;
        }
      })
      .finally(() => {
        setLoading(true);
      });
  };

  useEffect(() => {
    window.addEventListener(
      'scroll',
      handleOnScroll(() => getData(true)),
    );
    return () => {
      window.removeEventListener(
        'scroll',
        handleOnScroll(() => getData(true)),
      );
      cursor.current = '';
    };
  }, []);

  useEffect(() => {
    getData(false);
  }, []);

  return (
    <>
      <BackButton handleClick={() => history.push('/customers')} />
      {loading ? (
        policyList && policyList.list?.length > 0 ? (
          policyList.list?.map((value: any, index: any) => (
            <PoliciesListItem
              key={index}
              policiesListItem={value}
              currentLang={currentLang}
            />
          ))
        ) : (
          <EmptyView text={formatMessage({ id: 'You have no policy now.' })} />
        )
      ) : (
        <div style={{ marginTop: '100px' }}>
          <SkeletonLoading />
        </div>
      )}
    </>
  );
};

export default Policies;
